module.exports = __webpack_public_path__ + "static/media/photo30.7fc81364.png";